"use client";

import { createContext, useContext } from "react";
import { useTexasHoldem } from "./use-texas-holdem";

type PokerContextValue = ReturnType<typeof useTexasHoldem>;

const PokerContext = createContext<PokerContextValue | null>(null);

export function PokerProvider({ children }: { children: React.ReactNode }) {
  const poker = useTexasHoldem();
  return <PokerContext.Provider value={poker}>{children}</PokerContext.Provider>;
}

export function usePoker(): PokerContextValue {
  const ctx = useContext(PokerContext);
  if (!ctx) throw new Error("usePoker must be used within PokerProvider");
  return ctx;
}
